import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
import type { Afiliado } from "@/types";

/** Carga todas las solicitudes de afiliación (solo para administradores). */
export function useAfiliados() {
  const [afiliados, setAfiliados] = useState<Afiliado[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data, error: queryError } = await supabase
        .from("affiliates")
        .select("*")
        .order("creado_en", { ascending: false });
      if (queryError) throw queryError;
      setAfiliados((data as Afiliado[]) ?? []);
    } catch {
      setError("No pudimos cargar las solicitudes de afiliación. Revisa tu conexión e intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { afiliados, loading, error, reload: load, setAfiliados };
}